module.exports = __webpack_public_path__ + "static/media/i-strategies-logo.9eb970df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/i-strategies-logo.svg
// module id = 366
// module chunks = 0